import BaseApiService from '../base/BaseApiService';
import type { JobSchedule, UpdateJobScheduleRequest } from '@app-types/job-schedule';

class JobScheduleService extends BaseApiService {
  async getAll(): Promise<JobSchedule[]> {
    return this.get<JobSchedule[]>('/admin/job-schedules');
  }

  async getByName(jobName: string): Promise<JobSchedule> {
    return this.get<JobSchedule>(`/admin/job-schedules/${encodeURIComponent(jobName)}`);
  }

  async update(jobName: string, data: UpdateJobScheduleRequest): Promise<JobSchedule> {
    return this.put<JobSchedule>(`/admin/job-schedules/${encodeURIComponent(jobName)}`, data);
  }
}

export const jobScheduleService = new JobScheduleService();
